import Chip from '@material-ui/core/Chip';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import React from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tableCell: {
      borderBottom: 'none'
    },
    tableCellHeader: {
      borderBottom: 'none',
      paddingLeft: 0,
      maxWidth: 300,
      width: 300
    },
    dailyScheduleChipContainer: { 
      display: 'flex', 
      alignItems: 'center' 
    },
    dailyScheduleChip: { 
      marginRight: 8 
    }
  })
);

interface Props {
  workflow: any;
}

function WorkflowSettings(props: Props) {
  const { workflow } = props;
  const classes = useStyles({});

  return (
    <Table size="small">
      <TableBody>
        <TableRow>
          <TableCell className={classes.tableCellHeader}>Max Workflow Time</TableCell>
          <TableCell className={classes.tableCell}>
            <Typography>{workflow.MaxWorkflowTime ? `${workflow.MaxWorkflowTime} hours` : 'Not specified'}</Typography>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.tableCellHeader}>Max AWS Retries (0-12)</TableCell>
          <TableCell className={classes.tableCell}>
            <Typography>{workflow.MaxAWSRetries || 'Not Specified'}</Typography>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.tableCellHeader}>Termination Protection</TableCell>
          <TableCell className={classes.tableCell}>
            <Chip
              label={workflow.DisableTeardown ? 'Yes' : 'No'}
              color={workflow.DisableTeardown ? 'primary' : 'default'}
              size="small" variant={workflow.DisableTeardown ? 'default' : 'outlined'}
            />
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.tableCellHeader}>Daily Scheduled Tests</TableCell>
          <TableCell className={classes.tableCell}>
            <div className={classes.dailyScheduleChipContainer}>
              <Chip
                className={classes.dailyScheduleChip}
                label={workflow.EnableScheduledTests ? 'Enabled' : 'Disabled'}
                color={workflow.EnableScheduledTests ? 'primary' : 'default'}
                size="small" variant={workflow.EnableScheduledTests ? 'default' : 'outlined'}
              />
              {workflow.EnableScheduledTests && <Typography>(execution will run daily at {workflow.DailyScheduledExecutionTime || '2:00'} UTC time)</Typography>}
            </div>
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};

export default WorkflowSettings;
